module.exports = __webpack_public_path__ + "img/logoNavigator.70a843c2.png";